module.exports = __webpack_public_path__ + "img/computer.6a8e8a39.svg";